module.exports = __webpack_public_path__ + "img/icon_sjsj.9430322c.svg";